<template>
  <span
    v-if="value"
    v-bind="nonEventAttrs()"
    data-sb-regression="sb-text"
    v-on="eventAttrs()"
  >
    <template v-if="plural">
      {{ $tc(value, plural, params) }}
    </template>
    <template v-else-if="dateFormat">
      {{ $d(value, dateFormat) }}
    </template>
    <template v-else-if="numberFormat">
      {{ $n(Number(value), numberFormat) }}
    </template>
    <template v-else>
      {{ $t(value, params) }}
    </template>
  </span>
  <p
    v-else
    class="sb-text"
    v-bind="nonEventAttrs()"
    v-on="eventAttrs()"
  >
    <!--
    @slot text, components, or HtmlElements as children of the component.
    -->
    <slot />
  </p>
</template>

<script>
export default {
  name: 'SbText',
  props: {
    /**
     * Value of the translatable path `example.common.value`
     */
    value: {
      type: [String, Number],
      default: '',
    },
    /**
     * [Additional parameters](https://vue-i18n.intlify.dev/guide/essentials/pluralization.html) being passed to pluralization
     */
    plural: {
      type: Number,
      default: null,
    },
    /**
     * [Parameters](https://vue-i18n.intlify.dev/guide/essentials/syntax.html) being passed to translations
     */
    params: {
      type: Object,
      default: () => { },
    },
    /**
     * [Date Formats](https://vue-i18n.intlify.dev/guide/essentials/datetime.html) being passed to translations
     * Accepted values - `short` and `long`
     */
    dateFormat: {
      type: String,
      default: null,
      validator: (value) => {
        return value.match(/(short|long)/);
      },
    },
    /**
     * [Number Formats](https://vue-i18n.intlify.dev/guide/essentials/number.html) being passed to translations
     * Accepted values - `currency`, `percent` and `decimal`
     */
    numberFormat: {
      type: String,
      default: null,
      validator: (value) => {
        return value.match(/(currency|percent|decimal)/);
      },
    },
  },
  methods: {
    nonEventAttrs() {
      return Object.fromEntries(Object.entries(this.$attrs).filter(([key]) => !key.startsWith('on'))) || {};
    },
    eventAttrs() {
      const events = Object.fromEntries(Object.entries(this.$attrs).filter(([key]) => key.startsWith('on')));
      return Object.keys(events).length > 0 ? events : {};
    },
  },
};
</script>

<style lang='scss' scoped>
@import '@src/components/Text/style/sb-text.scss';
</style>
